"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTimeout = exports.AbortError = exports.TimeoutError = void 0;
class TimeoutError extends Error {
    constructor(timeoutInMs, customErrorContext) {
        super(customErrorContext === undefined
            ? `timed out after ${timeoutInMs} ms`
            : `${customErrorContext} (timed out after ${timeoutInMs} ms)`);
        this.code = 'TimeoutError';
        Error.captureStackTrace(this, TimeoutError);
    }
}
exports.TimeoutError = TimeoutError;
class AbortError extends Error {
    constructor(customErrorContext) {
        super(customErrorContext === undefined
            ? `aborted`
            : `${customErrorContext} aborted`);
        this.code = 'AbortError';
        Error.captureStackTrace(this, AbortError);
    }
}
exports.AbortError = AbortError;
const withTimeout = (task, timeoutInMs, customErrorContext, abortController) => {
    if (abortController?.signal?.aborted === true) {
        return Promise.reject(new AbortError(customErrorContext));
    }
    let timeoutRef;
    let abortListener;
    return Promise.race([
        task,
        new Promise((_resolve, reject) => {
            timeoutRef = setTimeout(() => {
                reject(new TimeoutError(timeoutInMs, customErrorContext));
            }, timeoutInMs);
            if (abortController !== undefined) {
                // TODO remove the type casting when type definition for abortController has been updated to include addEventListener
                abortListener = () => {
                    reject(new AbortError(customErrorContext));
                };
                abortController.signal.addEventListener('abort', abortListener);
            }
        })
    ]).finally(() => {
        clearTimeout(timeoutRef); // clear timeout if promise wins race
        if (abortListener !== undefined) {
            // TODO remove the type casting when type definition for abortController has been updated to include removeEventListener
            abortController.signal.removeEventListener('abort', abortListener);
        }
    });
};
exports.withTimeout = withTimeout;
//# sourceMappingURL=withTimeout.js.map